import { render, staticRenderFns } from "./claim_list.vue?vue&type=template&id=fa0bec82&scoped=true&"
import script from "./claim_list.vue?vue&type=script&lang=js&"
export * from "./claim_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0bec82",
  null
  
)

export default component.exports